import { SvgIcon, SvgIconProps } from '@mui/material';

const MoveItemIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="currentColor"
          d="M5.33341 13.3333V12.0167H6.66675V3.99999H5.33341V2.66666H6.66675C7.03342 2.66666 7.3473 2.79721 7.60842 3.05832C7.86953 3.31943 8.00008 3.63332 8.00008 3.99999V12C8.00008 12.3667 7.86953 12.6805 7.60842 12.9417C7.3473 13.2028 7.03342 13.3333 6.66675 13.3333H5.33341ZM10.6667 13.3333C10.3001 13.3333 9.98619 13.2028 9.72508 12.9417C9.46397 12.6805 9.33342 12.3667 9.33342 12V3.99999C9.33342 3.63332 9.46397 3.31943 9.72508 3.05832C9.98619 2.79721 10.3001 2.66666 10.6667 2.66666H14.0001C14.3667 2.66666 14.6806 2.79721 14.9417 3.05832C15.2029 3.31943 15.3334 3.63332 15.3334 3.99999V12C15.3334 12.3667 15.2029 12.6805 14.9417 12.9417C14.6806 13.2028 14.3667 13.3333 14.0001 13.3333H10.6667ZM10.6667 12.0167H14.0001V3.99999H10.6667V12.0167ZM3.33341 10.6667L2.38341 9.73332L3.43341 8.66666H0.666748V7.33332H3.43341L2.38341 6.28332L3.33341 5.33332L6.00008 7.99999L3.33341 10.6667Z"
        />
      </svg>
    </SvgIcon>
  );
};

export default MoveItemIcon;
